import { referencablePropType_Abstract, referencablePropType_Compose, referencablePropType_Inherit, referencablePropType_Internal } from './types.js';
export const referencablePropType_LabelMap = {
    [referencablePropType_Inherit]: 'Inherit',
    [referencablePropType_Abstract]: 'Abstract',
    [referencablePropType_Compose]: 'Compose',
    [referencablePropType_Internal]: 'Internal',
};
export const referencablePropType_ConflictMap = {
    [referencablePropType_Inherit]: [],
    [referencablePropType_Abstract]: [],
    [referencablePropType_Compose]: [],
    [referencablePropType_Internal]: [],
};
//# sourceMappingURL=consts.js.map